import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-branch-settings',
  templateUrl: './branch-settings.component.html',
  styleUrls: ['./branch-settings.component.css']
})
export class BranchSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
